import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stats: null,
    userDistribution: null,
    revenueBreakdown: null,
    tournamentStatus: null,
    loading: false,
    error: null,
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setStats: (state, action) => {
            state.stats = action.payload;
        },
        setUserDistribution: (state, action) => {
            state.userDistribution = action.payload;
        },
        setRevenueBreakdown: (state, action) => {
            state.revenueBreakdown = action.payload;
        },
        setTournamentStatus: (state, action) => {
            state.tournamentStatus = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearDashboard: (state) => {
            state.stats = null;
            state.userDistribution = null;
            state.revenueBreakdown = null;
            state.tournamentStatus = null;
        },
    },
});

export const {
    setStats,
    setUserDistribution,
    setRevenueBreakdown,
    setTournamentStatus,
    setLoading,
    setError,
    clearDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
